import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import DetailsLeft from '@blade/common/pages/result-details/components/details-left.vue';
import DetailsRight from '@blade/common/pages/result-details/components/details-right.vue';
import DetailsRightTask from '@blade/common/pages/result-details/components/details-right-task.vue';
import DetailsToggle from '@blade/common/pages/result-details/components/details-toggle.vue';
import { fromPage } from '@blade/common/interfaces/result-details';
import { resultType } from '@blade/common/pages/result-details/common/config';
import { getTaskTargetStr } from '@blade/common/pages/result-details/common/util';
let Details = class Details extends Vue {
    openDetails;
    detailsData;
    detailsIndex;
    detailsRoute;
    showPath;
    loading;
    maxNum;
    detailsTaskType;
    sourceImage;
    activeNameTab;
    isToggle;
    isRouteBtn;
    isChartType;
    onDetails() {
        if (!(this.detailsData?.length === 0 || this.detailsData?.toString() === '{}')) {
            this.initData();
        }
    }
    onDetailsIndex(newVal) {
        if (this.detailsData?.length >= newVal + 1) {
            this.initData();
        }
    }
    detailsLeftRef;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    filterImgLv = this.privacyMode === 'true' ? 6 : 0;
    objectType = '';
    isDetailsLeftBottom = false;
    isDetailsRightBottom = true;
    isTaskResult = false;
    detailsShowContentList = [];
    details = {};
    type = '';
    detailsType = '';
    offset = {};
    // 添加脑图子节点
    addChart(data) {
        this.$emit('addChart', data);
    }
    initData() {
        this.$nextTick(() => {
            this.getOffset();
        });
        if (this.detailsRoute === fromPage.TEXT) {
            this.detailsType = 'OBJECT_EVERYTHING';
            this.details = this.detailsData?.[this.detailsIndex];
        }
        else if (this.detailsRoute === fromPage.FILECLUSTER_PAGE || this.detailsRoute === fromPage.BIGDATA_PAGE) {
            this.detailsType = 'OBJECT_FACE';
            this.details = this.detailsData;
        }
        else if (this.detailsRoute === fromPage.TASK_PAGE) {
            this.details = this.detailsData?.[this.detailsIndex];
            // 告警
            if (this.details?.isDetailsType) {
                this.detailsType = this.details.incidentType;
                this.isTaskResult = true;
            }
            else {
                // 解析结果
                this.detailsType = this.details.trackType;
            }
        }
        else {
            this.detailsType = this.detailsTaskType;
            this.details = this.detailsData?.[this.detailsIndex];
        }
        if (this.details?.checked || this.details?.userSpaceExistsVOS?.[0]?.exists) {
            this.$emit('show', false);
        }
        else {
            this.$emit('show', true);
        }
        this.type = getTaskTargetStr('incidentType', 'type', this.detailsType);
        this.getResultType();
        this.getObjectType();
    }
    getOffset() {
        if (this.openDetails) {
            this.offset.x = (window.innerWidth - this.$refs.detailsRef.offsetWidth) / 2;
            this.offset.y = (window.innerHeight - this.$refs.detailsRef.offsetHeight) / 2;
        }
    }
    getObjectType() {
        this.isDetailsLeftBottom = false;
        // console.log('this.detailsRoute', this.detailsRoute, fromPage.FILECLUSTER_PAGE, this.type);
        if (this.type === 'Face' || this.type === 'Automobile' || this.type === 'MotorBike') {
            this.isDetailsLeftBottom = true;
        }
        // this.detailsRoute === fromPage.FILECLUSTER_PAGE || && this.detailsRoute !== fromPage.FILECLUSTER_PAGE
        if (this.detailsRoute === fromPage.BIGDATA_PAGE) {
            this.isDetailsRightBottom = false;
        }
    }
    closeDetails() {
        this.$emit('close-details');
    }
    next() {
        this.$emit('next');
    }
    prev() {
        this.$emit('prev');
    }
    addRoute(checkRoute, flag, index) {
        this.$emit('add-route', checkRoute, flag, index);
    }
    deleteRoute(routeData, flag, index) {
        this.$emit('deleted-route', routeData, flag, index);
    }
    onFullScreen(type) {
        this.$refs.detailsLeftRef.onFullScreen(type);
    }
    isValidKey(key, object) {
        return key in object;
    }
    toggleLoadingHandle(val) {
        this.$refs.detailsToggleRef.getLoading(val);
    }
    // 处理显示的类型
    getResultType() {
        if (this.type === 'Crowd' || this.type === 'Object') {
            this.detailsShowContentList = resultType['crowdEvent'];
            return;
        }
        if (this.detailsRoute === fromPage.EVENT_PAGE && this.type === 'Face') {
            this.detailsShowContentList = resultType['time'];
            return;
        }
        if (this.detailsRoute === fromPage.TIME_PAGE && this.type === 'Automobile') {
            this.detailsShowContentList = resultType['car'];
            return;
        }
        if (this.detailsRoute === fromPage.FEATURES_PAGE && this.type === 'Automobile') {
            this.detailsShowContentList = resultType['Automobile'];
            return;
        }
        if (this.detailsRoute === fromPage.TASK_PAGE && !this.details.isDetailsType) {
            this.detailsShowContentList = resultType['time'];
            return;
        }
        if (this.detailsRoute === fromPage.TEXT) {
            this.detailsShowContentList = resultType['ObjectEverything'];
        }
        if (this.isValidKey(this.detailsRoute, resultType)) {
            this.detailsShowContentList = resultType[this.detailsRoute];
        }
    }
    addChartDetect(val) {
        this.$emit('addChartDetect', val);
    }
};
__decorate([
    Prop()
], Details.prototype, "openDetails", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsData", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsIndex", void 0);
__decorate([
    Prop({ default: 'event' })
], Details.prototype, "detailsRoute", void 0);
__decorate([
    Prop()
], Details.prototype, "showPath", void 0);
__decorate([
    Prop()
], Details.prototype, "loading", void 0);
__decorate([
    Prop()
], Details.prototype, "maxNum", void 0);
__decorate([
    Prop({ default: 'alert' })
], Details.prototype, "detailsTaskType", void 0);
__decorate([
    Prop()
], Details.prototype, "sourceImage", void 0);
__decorate([
    Prop()
], Details.prototype, "activeNameTab", void 0);
__decorate([
    Prop({ default: true })
], Details.prototype, "isToggle", void 0);
__decorate([
    Prop({ default: true })
], Details.prototype, "isRouteBtn", void 0);
__decorate([
    Prop()
], Details.prototype, "isChartType", void 0);
__decorate([
    Watch('detailsData', { immediate: true, deep: true })
], Details.prototype, "onDetails", null);
__decorate([
    Watch('detailsIndex')
], Details.prototype, "onDetailsIndex", null);
__decorate([
    Ref()
], Details.prototype, "detailsLeftRef", void 0);
Details = __decorate([
    Component({
        name: 'Details',
        components: { DetailsLeft, DetailsRight, DetailsToggle, DetailsRightTask },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
